import React from 'react';
import RadioButton from 'Components/common/RadioBtn';

const SelectExportType = props => {
  const {
    closePopup,
    addSequence,
    getToogleValue,
    addContact,
    continueExport,
  } = props;

  return (
    <>
      <div className="overlayMask" />
      <div className="aeExportCrmSection">
        <div className="aeCard popupAnimate popupScaleIn">
          <div className="aeTitle">
            <i className="material-icons closePopup" onClick={closePopup}>
              close
            </i>
            <h4>Salesgear Export</h4>
          </div>
          <div className="aeBody">
            <RadioButton
              name="exportCrm"
              id="addToSeq"
              label="Add to a Sequence"
              value="Add to a Sequence"
              checked={addSequence}
              onChange={() => getToogleValue('', 'addToSeq')}
            />
            <RadioButton
              name="exportCrm"
              id="exportContact"
              label="Export to Salesgear"
              value="Export to Salesgear"
              checked={addContact}
              onChange={() => getToogleValue('', 'exportContact')}
            />
          </div>
          <div className="aeFooter">
            <button
              type="button"
              className="continueBtn"
              onClick={continueExport}
            >
              Continue
            </button>
            <button type="button" className="cancelBtn" onClick={closePopup}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectExportType;
export { SelectExportType };
